import { ReactNode } from 'react';

interface SectionBodyProps {
  /** The JSX content for the setting. */
  children: ReactNode;
}

/**
 * Represents the body of a trade settings section .
 */
export const SectionBody = ({ children }: SectionBodyProps): React.ReactElement => (
  <div className="flex flex-col">{children}</div>
);
